import api from "./Api";

class SuporteService {
    async inserir(assunto: string, descricao: string, anexos: string[], clienteId: number | null = null): Promise<void> {
        await api.post('Suporte', {
            assunto,
            descricao,
            anexos,
            clienteId
        });
    }

    async listar(): Promise<any[]> {
        let { data: result } = await api.get<any[]>(`Suporte`);
        return result;
    }

    async andamento(id: number): Promise<void> {
        await api.put(`Chat/andamento/${id}`, null, {
            baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
        });
    }

    async anexar(id: number, anexo: string): Promise<void> {
        await api.put(`Chat/anexar/${id}`, {
            anexo
        }, {
            baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
        });
    }

    async finalizar(id: number): Promise<void> {
        await api.put(`Chat/finalizar/${id}`, null, {
            baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
        });
    }

    async responder(id: number, resposta: string): Promise<void> {
        await api.put(`Suporte/responder`, {
            id,
            resposta
        });
    }

    async listarTodos(): Promise<any[]> {
        let { data: result } = await api.get<any[]>(`Suporte/all`);
        return result;
    }

    async enviarMensagem(suporteID: number, mensagem: string): Promise<void> {
        return await api.post(`Chat/EnviarMensagem/${suporteID}`, {
            mensagem
        }, {
            baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
        });
    }

    async buscarMensagens(suporteID: number): Promise<any[]> {
        const { data: result } = await api.get<any[]>(`Chat/${suporteID}`, {
            baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
        });

        return result;
    }
}


export default new SuporteService();